import React, { useState, useContext }from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonModal } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';


//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/zPublic.css';
import '../../css/layout.css';


 export function Hotel_PrivacyStatement(props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    return (
            <React.Fragment>
            {(props.openModal == true) &&
                (
                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{ color: "black" }}>
                        <h1>PRIVACY STATEMENT</h1>
                    </IonHeader>

                    <IonContent className='privacy_statement'>
                        <p className='professional-text'>

                        Privacy Statement for Ghana Verified

                        Data Collection:
                        Ghana Verified collects certain information to provide and improve its services. This includes personal information, such as your name, email address, or phone number, as well as non-personal information, such as device information and usage data.

                        Usage of Information:
                        Ghana Verified uses the collected data to deliver and personalize the app's functionality, improve user experience, and develop new features.

                        Information Sharing:
                        Ghana Verified does not share personal information with third parties. Aggregated or anonymized data that does not personally identify users may be shared for analytical or research purposes.

                        Security Measures:
                        Ghana Verified takes measures to protect the information it collects, including the use of encryption and access controls to ensure data security.

                        Cookies and Similar Technologies:
                        Ghana Verified may use cookies, web beacons, and other tracking technologies to collect information and improve the app's functionality or personalize content.

                        User Controls and Choices:
                        Ghana Verified provides options for users to manage their privacy settings and control the types of information collected. This may include settings related to location data or app permissions.

                        Third-Party Services:
                        If Ghana Verified integrates with third-party services or includes links to external websites, this privacy statement clarifies that those services have their own privacy practices, and Ghana Verified is not responsible for how they handle your information.
                        </p>

                    </IonContent>
                    <IonFooter class='appFooter'>
                        <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                    </IonFooter>

                    {/*<App_Footer></App_Footer>*/}
                    </IonModal>
                )
                }
            </React.Fragment>

    );
};



export default Hotel_PrivacyStatement;